import { Providers } from "./providers";
import { Router } from "./router";

export function App() {
  return (
    <Providers>
      <Router />
    </Providers>
  );
}
